<script>
    import { required, minLength, numeric } from "vuelidate/lib/validators";
    import validationMessages from '@/components/validations'
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import Games from "@/services/Games";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    export default {
        components:{
            validationMessages
        },
        props: ['questionId',],
        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                answer:'',
                submitted: false,
                showModal: false,
                tryingToEdit: false,
                verified_checked: true,
            };
        },
            validations: {
              answer:{
                 required
               },


            },

        methods: {

            async addAnswer(){
                this.tryingToEdit = true;
                this.submitted = true;
                this.$v.$touch()

                if (this.$v.$invalid) {
                    this.tryingToEdit = false;
                    return;
                } else {
                    try {
                        await Games.addAnswer({
                            answer: this.answer,
                            question_id: this.questionId,
                        }).then((response) => {
                            this.successmsg("Changes has been saved");
                            this.closeModal();
                        }).catch(error => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg(this.error)
                        }).finally(() => {
                            this.refreshData()
                            this.tryingToEdit = false
                        })
                    } catch (error) {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg(this.error)
                    }
                }
                this.tryingToEdit = false;
            },

            refreshData() {
                this.$emit('onRefresh')
            },
            closeModal() {
                this.showModal = false
                this.resetProps()
            },
            resetProps(){
               this.answer = ''
              this.submitted = false
            }
        },
    };
</script>

<template>
    <b-modal v-model="showModal" @hidden="resetProps"  id="add_new_answer" title=" Add new Answer" title-class="font-18" size="md" centered>
        <form @submit.prevent="addAnswer">
            <div class="row">
                <div class="col-12">
                    <b-form-group label-for="formrow-answer-input" class="mb-3">
                      <label for="name">Answer</label>
                      <b-form-input
                          v-model.trim="answer"
                          type="text"
                          id="answer"
                          aria-describedby="answer"
                          :class="{
                                  'is-invalid': submitted && $v.answer.$error,
                                }"
                      >
                      </b-form-input>
                      <validationMessages v-if="submitted" :fieldName="'Poll Answer'" :validationName="$v.answer"></validationMessages>
                    </b-form-group>
                </div>
            </div>
            <input type="hidden" name="csrf_token" v-model="csrf_token">
        </form>

        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="addAnswer" :disabled="tryingToEdit">
                <b-spinner v-show="tryingToEdit" small></b-spinner>
                Submit</b-button>
        </template>
    </b-modal>
</template>